import pageStyles from "../components/ui/PageBox.module.css";

function InquiryPage() {
  return <div className={pageStyles.pageBox}></div>;
}

export default InquiryPage;
